import { useState, useEffect } from 'react'

/**
 * Tracks whether the viewport is at or below `breakpoint` (i.e. mobile).
 *
 * Uses a matchMedia `change` listener rather than a `resize` handler so it reacts
 * deterministically in BOTH directions when the breakpoint is crossed — including
 * browser device-mode emulation toggling, which does not reliably emit `resize`.
 */
const useIsMobile = (breakpoint = 768): boolean => {
  const query = `(max-width: ${breakpoint}px)`
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    const handleChange = (event: MediaQueryListEvent) => setIsMobile(event.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [query])

  return isMobile
}

export default useIsMobile